//
// ─── GET REQUESTS ───────────────────────────────────────────────────────────────
//

import { REST_HOST } from '../../../env.config';
import { request } from '../../common/src/legacy/services/httpSessionService';
import { DistributionPortfolio } from '../types/apiTypes';

const origin = REST_HOST;

export const getLegalPortfolioForDistribution = async (
  distributionId: string,
  filter?: string,
): Promise<[DistributionPortfolio, number]> => {
  const query = filter ? `&q=${filter}` : '';

  const path = `v1/api/broker/v1/api/distributions/${distributionId}/prospects?statute=COMPANY&pagelen=5&page=1${query}`;
  const [resp, status] = await request({ path, origin });

  return [resp, status];
};
